import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { push, replace } from 'connected-next-router';

import { buildListingsURL } from 'src/adapters/storeToPageURL/builders/buildListingsURL';
import {
  buildFilterPathFromState,
  buildListingsQueryParams,
} from 'src/adapters/storeToPageURL/state/buildListingsQueryParams';
import { buildListingsURLFromState } from 'src/adapters/storeToPageURL/state/buildListingsURLFromState';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

interface UpdatePageURLWithQueryOptions {
  history?: 'push' | 'replace';
}

export const updatePageURLWithQuery = createAsyncThunk<void, UpdatePageURLWithQueryOptions | void>(
  'products/updatePageURLWithQuery',
  async (options, { dispatch, getState }) => {
    const { history = 'push' } = options ?? {};
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const routerPathname = selectRouterPathname(state);
    const { page, taxonomyAttributeAliases = [] } = state.productsQuery;

    if (taxonomyAttributeAliases.length > 0) {
      const url = buildListingsURLFromState(state);
      dispatch((history === 'push' ? push : replace)(url, url, { shallow: true, scroll: false }));
      return;
    }

    const urlParams = buildListingsQueryParams(state, { page });
    const filterPath = buildFilterPathFromState(state);
    const href = buildListingsURL(routerPathname, filterPath, urlParams, state.navigation.hash);
    const as = buildListingsURL(pathname, filterPath, urlParams, state.navigation.hash);

    dispatch((history === 'push' ? push : replace)(href, as, { shallow: true, scroll: false }));
  },
);
